// CHADA Store — main JS entry. Lightweight feature modules, no framework.

import { initSiteHeader } from './modules/site-header.js';
import { initMobileNav } from './modules/mobile-nav.js';
import { initBackToTop } from './modules/back-to-top.js';
import { initSmoothScroll } from './modules/smooth-scroll.js';
import { initCategoryFilter } from './modules/category-filter.js';
import { initRevealOnScroll } from './modules/reveal.js';
import { initShopSidebar } from './modules/shop-sidebar.js';

document.addEventListener('DOMContentLoaded', () => {
	initSiteHeader();
	initMobileNav();
	initBackToTop();
	initSmoothScroll();
	initCategoryFilter();
	initRevealOnScroll();
	initShopSidebar();
});
